"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TableauUI = require("@tableau/tableau-ui");
var React = require("react");
var TypeStyle = require("typestyle");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var TextFieldBase_1 = require("./TextFieldBase");
exports.TextInputType = TextFieldBase_1.TextInputType;
var TextFieldWidget_1 = require("./TextFieldWidget");
var ShimStyleName = TypeStyle.style({
    display: 'block',
    $nest: {
        '& input': { width: '100%' }
    }
});
var getLabelStyleName = function (labelStyle) { return TypeStyle.style({
    $nest: {
        '& label': labelStyle
    }
}); };
var getMessageStyleName = function (messageStyle) { return TypeStyle.style({
    $nest: {
        '& .message': messageStyle
    }
}); };
function handleFocus(e) {
    if (DomUtil_1.shouldIgnoreFocusEvent(e)) {
        return;
    }
    var input = e.target;
    window.setTimeout(function () {
        // Defect 706678: only certain element types support setSelectionRange, but Safari prefers it
        try {
            if (input.value) {
                input.setSelectionRange(0, input.value.length);
            }
        }
        catch (e) {
            input.select();
        }
    });
}
var LegacyTextFieldShim = /** @class */ (function (_super) {
    tslib_1.__extends(LegacyTextFieldShim, _super);
    function LegacyTextFieldShim() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComposing = false;
        _this.enterDown = false;
        _this.escDown = false;
        _this.handleBlur = function (e) {
            _this.enterDown = false;
            _this.escDown = false;
            if (_this.props.handleBlur) {
                _this.props.handleBlur(e);
            }
        };
        _this.handleChange = function (e) {
            if (_this.props.disabled || !_this.props.handleChange) {
                return;
            }
            _this.isComposing = e.isComposing;
            _this.props.handleChange(e.target.value, _this.isComposing);
        };
        _this.handleKeyDown = function (e) {
            if (_this.props.disabled || _this.isComposing) {
                return;
            }
            if (e.key === 'Enter' && _this.props.handleEnter) {
                _this.enterDown = true;
            }
            else if (e.key === 'Escape' && _this.props.handleEscape) {
                _this.escDown = true;
            }
            else if (_this.props.onKeyDown) {
                _this.props.onKeyDown(e);
            }
        };
        _this.handleKeyUp = function (e) {
            if (_this.props.disabled || _this.isComposing) {
                return;
            }
            if (e.key === 'Enter' && _this.props.handleEnter && _this.enterDown) {
                _this.enterDown = false;
                _this.props.handleEnter();
            }
            else if (e.key === 'Escape' && _this.props.handleEscape && _this.escDown) {
                _this.escDown = false;
                _this.props.handleEscape();
            }
            else if (_this.props.onKeyUp) {
                _this.props.onKeyUp(e);
            }
        };
        return _this;
    }
    LegacyTextFieldShim.prototype.render = function () {
        var _a = this.props, className = _a.className, containerStyle = _a.containerStyle, handleBlur = _a.handleBlur, handleChange = _a.handleChange, handleEnter = _a.handleEnter, handleEscape = _a.handleEscape, inputRef = _a.inputRef, inputStyle = _a.inputStyle, onDarkBackground = _a.onDarkBackground, placeholderStyle = _a.placeholderStyle, shouldSelectTextOnFocus = _a.shouldSelectTextOnFocus, text = _a.text, type = _a.type, textFieldProps = tslib_1.__rest(_a, ["className", "containerStyle", "handleBlur", "handleChange", "handleEnter", "handleEscape", "inputRef", "inputStyle", "onDarkBackground", "placeholderStyle", "shouldSelectTextOnFocus", "text", "type"]);
        if (placeholderStyle) {
            // intentionally ignored in the new world, native placeholder doesn't need this
        }
        return (React.createElement(TextFieldWidget_1.TextFieldWidget, tslib_1.__assign({}, textFieldProps, { className: TypeStyle.classes(className, ShimStyleName, TypeStyle.style(containerStyle), onDarkBackground && 'dark'), onBlur: this.handleBlur, onChange: this.handleChange, onFocus: shouldSelectTextOnFocus ? handleFocus : undefined, onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, ref: inputRef, style: inputStyle, type: type, value: text })));
    };
    LegacyTextFieldShim.defaultProps = Object.freeze({
        shouldSelectTextOnFocus: true,
        text: '',
        type: TextFieldBase_1.TextInputType.Text,
    });
    LegacyTextFieldShim.displayName = 'LegacyTextFieldShim';
    return LegacyTextFieldShim;
}(React.Component));
exports.LegacyTextFieldShim = LegacyTextFieldShim;
/** @deprecated use `TextFieldWidget` with `kind='line'` */
exports.LineTextFieldWidget = function (props) {
    var errorText = props.errorText, hideErrorDiv = props.hideErrorDiv, floatingLabel = props.floatingLabel, floatingLabelStyle = props.floatingLabelStyle, textFieldBaseProps = tslib_1.__rest(props, ["errorText", "hideErrorDiv", "floatingLabel", "floatingLabelStyle"]);
    return (React.createElement(LegacyTextFieldShim
    // this is not WCAG-compliant but it's what the old widget did
    , tslib_1.__assign({}, (hideErrorDiv && { 'aria-errormessage': undefined, 'aria-describedby': undefined }), textFieldBaseProps, { className: TypeStyle.classes(floatingLabelStyle && getLabelStyleName(floatingLabelStyle), hideErrorDiv && getMessageStyleName({ display: 'none' })), kind: 'line', message: errorText || '\u200B', label: floatingLabel, valid: (!hideErrorDiv && !!errorText) ? false : undefined })));
};
// tslint:disable-next-line:deprecation
exports.LineTextFieldWidget.displayName = 'LineTextFieldWidget';
/** @deprecated use `TextFieldWidget` with `kind='outline'` */
exports.OutlineTextFieldWidget = function (props) {
    var displayErrorTextSection = props.displayErrorTextSection, errorText = props.errorText, handleClearText = props.handleClearText, hasError = props.hasError, textFieldBaseProps = tslib_1.__rest(props, ["displayErrorTextSection", "errorText", "handleClearText", "hasError"]);
    return (React.createElement(LegacyTextFieldShim
    // this is not WCAG-compliant but it's what the old widget did
    , tslib_1.__assign({}, (!displayErrorTextSection && { 'aria-errormessage': undefined, 'aria-describedby': undefined }), textFieldBaseProps, { className: TypeStyle.classes(!displayErrorTextSection && getMessageStyleName({ display: 'none' })), kind: 'outline', message: hasError ? errorText : '\u200B', onClear: handleClearText, valid: hasError ? false : undefined })));
};
// tslint:disable-next-line:deprecation
exports.OutlineTextFieldWidget.displayName = 'OutlineTextFieldWidget';
/** @deprecated use `TextFieldWidget` with `kind='search'` */
exports.SearchFieldWidget = function (props) {
    var handleCancelSearch = props.handleCancelSearch, textFieldBaseProps = tslib_1.__rest(props, ["handleCancelSearch"]);
    return (React.createElement(LegacyTextFieldShim
    // this is not WCAG-compliant but it's what the old widget did
    , tslib_1.__assign({ "aria-errormessage": undefined, "aria-describedby": undefined }, textFieldBaseProps, { kind: 'search', onClear: handleCancelSearch })));
};
// tslint:disable-next-line:deprecation
exports.SearchFieldWidget.displayName = 'SearchFieldWidget';
exports.IntegerStepperWidget = function (props) {
    // tslint:disable-next-line:max-line-length
    var containerStyle = props.containerStyle, delta = props.delta, handleBlur = props.handleBlur, inputStyle = props.inputStyle, labelStyle = props.labelStyle, onDarkBackground = props.onDarkBackground, onValueUpdated = props.onValueUpdated, pageDelta = props.pageDelta, shouldSelectTextOnFocus = props.shouldSelectTextOnFocus, start = props.start, testId = props.testId, htmlProps = tslib_1.__rest(props, ["containerStyle", "delta", "handleBlur", "inputStyle", "labelStyle", "onDarkBackground", "onValueUpdated", "pageDelta", "shouldSelectTextOnFocus", "start", "testId"]);
    var _a = React.useState(start), value = _a[0], setValue = _a[1];
    // TFS 969470 -- reset the value if `props.start` changes
    React.useEffect(function () { return setValue(props.start); }, [props.start]);
    return React.createElement(TableauUI.Stepper, tslib_1.__assign({}, htmlProps, { className: TypeStyle.classes(TypeStyle.style(containerStyle), labelStyle && getLabelStyleName(labelStyle), onDarkBackground && 'dark'), "data-tb-test-id": Declarative_1.testId(testId, 'IntegerStepperWidget', 'TextInput'), floatingPoint: false, onBlur: handleBlur, onFocus: shouldSelectTextOnFocus ? handleFocus : undefined, onValueChange: function (newValue) {
            setValue(newValue);
            onValueUpdated(newValue);
        }, pageSteps: pageDelta / delta, step: delta, style: inputStyle, value: value }));
};
exports.IntegerStepperWidget.displayName = 'IntegerStepperWidget';
//# sourceMappingURL=TextFieldWidgetShims.js.map